<template>
  <div class="solvents">
    <div
      class="card"
      v-for="data in datas"
      :key="data.title"
      @mouseenter="mouseover(data.imgSrcDetail)"
    >
      <!-- <img class="img" :src="data.src" /> -->
      <div class="info">
        <p class="title">
          <span class="text-title">{{ data.title }}</span>
        </p>
        <p class="intro">{{ data.intro }}</p>
        <!-- <div class="btn" @click="showDetailed(data.imgSrcDetail)">Detailed</div> -->
        <!-- <div class="btn">
          Detailed
        </div> -->
      </div>
    </div>
    <el-drawer
      title="我是标题"
      :visible="visible"
      :with-header="false"
      @close="closed"
      size="60%"
    >
      <components :is="currentSrcStr" />
      <!-- <img :src="imgDetails[currentSrcStr]" alt="currentSrc" style="width:700px" /> -->
    </el-drawer>
  </div>
</template>

<script>
// import GAAdetail from "./imgs/GAAdetail.png";
// import BAdetail from "./imgs/BAdetail.png";
// import EHAdetail from "./imgs/EHAdetail.png";
// import HPAdetail from "./imgs/HPAdetail.png";
// import HPMAdetail from "./imgs/HPMAdetail.png";
// import MAAdetail from "./imgs/MAAdetail.png";
// import MMAdetail from "./imgs/MMAdetail.png";
// import VAMdetail from "./imgs/VAMdetail.png";

import { debounce } from "lodash";
import GAAdetail from "./GAAdetail.vue";
import BAdetail from "./BAdetail.vue";
import EHAdetail from "./EHAdetail.vue";
import MAAdetail from "./MAAdetail.vue";
import MMAdetail from "./MMAdetail.vue";
import VAMdetail from "./VAMdetail.vue";

export default {
  name: "Solvents",
  components: {
    GAAdetail,
    BAdetail,
    EHAdetail,
    MAAdetail,
    MMAdetail,
    VAMdetail,
  },
  data() {
    return {
      visible: false,
      currentSrcStr: "GAAdetail",
      // imgDetails: {
      //   GAAdetail,
      //   BAdetail,
      //   EHAdetail,
      //   HPAdetail,
      //   HPMAdetail,
      //   MAAdetail,
      //   MMAdetail,
      //   VAMdetail,
      // },
      datas: [
        {
          title: "Glacial Acrylic Acid(GAA)",
          intro: "CAS No.: 79-10-7",

          imgSrcDetail: "GAAdetail",
        },
        {
          title: "Butyl Acrylate(BA)",
          intro: "CAS No.: 141-32-2 Molecular formula: C7H12O2",

          imgSrcDetail: "BAdetail",
        },
        {
          title: "2-Ethylhexyl Acrylate(2-EHA)",
          intro: "Molecular formula: C11H20O2 CAS No.: 103-11-7",

          imgSrcDetail: "EHAdetail",
        },
        // {
        //   title: "Hydroxypropyl Acrylate(HPA)",
        //   intro:
        //     "PRODUCTS NAME Hydroxypropyl Acrylate(HPA) 丙烯酸羟丙酯 ......",

        //   imgSrcDetail: "HPAdetail",
        // },

        // {
        //   title: "Hydroxypropyl Methacrylate(HPMA)",
        //   intro: "......",

        //   imgSrcDetail: "HPMAdetail",
        // },
        {
          title: "Methacrylic Acid (MAA)",
          intro: "CAS NO.: 79-41-1",

          imgSrcDetail: "MAAdetail",
        },

        {
          title: "Methyl Methacrylate (MMA)",
          intro: "CAS NO.: 80-62-6",

          imgSrcDetail: "MMAdetail",
        },
        {
          title: "Vinyl Acetate Monomer",
          intro:
            "VAM is a key ingredient in emulsion polymers, resins, and intermediates",

          imgSrcDetail: "VAMdetail",
        },
      ],
    };
  },
  methods: {
    showDetailed(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    mouseover(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    closed() {
      this.visible = false;
    },
  },
  mounted() {
    this.mouseover = debounce(this.mouseover, 700);
  },
};
</script>

<style lang="less" scoped>
.solvents {
  .card {
    display: flex;
    background-color: #fff;
    margin-bottom: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    border-radius: 10px;
    // .img {
    //   display: block;
    //   position: relative;
    //   z-index: 2;
    //   width: 260px;
    //   border-right: solid 1px #ddd;
    // }
    .title {
      padding-left: 30px;
      line-height: 60px;
    }
    .text-title {
      font-size: 26px;
      color: #333;
    }
    &:hover {
      .text-title {
        animation: text-title 1s linear;
        animation-name: text-title;
        animation-delay: 0s;
        animation-timing-function: linear;
        animation-duration: 0.7s;
      }
    }
    @keyframes text-title {
      0% {
        margin-left: 0;
      }
      50% {
        margin-left: 50px;
        color: rgba(8, 84, 132, 1);
      }
      100% {
        margin-left: 0;
      }
    }
    .info {
      height: 150px;
      position: relative;
      z-index: 1;
      width: 100%;
      &:hover {
        .btn {
          background-color: rgba(8, 84, 132, 1);
          transform: scale(1.2);
        }
      }
      .intro {
        font-size: 18px;
        color: #777;
        padding-left: 30px;
      }
      .btn {
        cursor: pointer;
        margin-left: 30px;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 150px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: rgba(8, 84, 132, 0.7);
        transition: transform 0.8s linear;
      }
    }
  }
}
</style>
